
















import { Component, Vue, Prop } from "vue-property-decorator";
import _ from "lodash";

import { UserService } from "@/core/services";
import {
  UserCollectionModel,
  AutoCompleteItem,
  DataFilter,
} from "@/core/models";

@Component
export default class UserSelectorCpt extends Vue {
  @Prop() onSelected?: (user: AutoCompleteItem) => void;
  @Prop() findMethod?: (search: string) => Promise<UserCollectionModel[]>;

  state = "";
  foundUsers: UserCollectionModel[] | null = null;

  async find(search: string, callback: (items: AutoCompleteItem[]) => any) {
    if (!search) {
      callback([]);
      return;
    }

    this.foundUsers = null;

    const users = this.findMethod
      ? await this.findMethod(search)
      : await UserService.find({
          search,
        } as DataFilter);

    this.foundUsers = users;
    callback(this.formatUserList(users));
  }

  onSelectedInternal(user: AutoCompleteItem) {
    if (this.onSelected) {
      this.onSelected(user);
      this.state = "";
    }
  }

  private formatUserList(users: UserCollectionModel[]) {
    return _.map(users, user => {
      return {
        id: user.id,
        value: `${user.firstName} ${user.lastName} (${user.email})`,
      };
    });
  }
}
